import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import BookingHelper from '../components/BookingHelper';

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
  Exo2: {
    normal: `${window.location.origin}/fonts/Exo2-Regular.ttf`,
    bold: `${window.location.origin}/fonts/Exo2-Bold_0.otf`,
  },
  Roboto: {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
    italics: 'Roboto-Italic.ttf',
    bolditalics: 'Roboto-MediumItalic.ttf',
  },
};

const border = [0, 0, 0, 0];
const listIcons = {
  airplan:
    'data:image/png;base64,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',
  truck:
    'data:image/png;base64,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',
};

const getHeader = (title) => {
  const header = {
    columns: [
      {
        width: '15%',
        text: '',
      },
      {
        width: '*',
        stack: [
          {
            text: title,
            style: 'header',
            margin: [0, 30, 0, 0],
          },
          {
            text: 'This is a draft. The final order will be sent seperately',
            style: 'header',
            // margin: [0, 25, 0, 0],
            fontSize: 10,
          },
        ],
      },
      {
        text: '',
        width: '15%',
        alignment: 'right',
      },
    ],
  };

  return header;
};

const getPickupInfo = (fleg, tleg) => {
  let flight = fleg;
  if (tleg && tleg.fnumber) {
    flight = tleg;
  }

  const dTime = BookingHelper.getDate(flight.std, 'DD/MM/YYYY HH:mm');
  const shipmentTime = dTime.format('DD/MM/YYYY HH:mm');

  const columnPickup = {
    stack: [
      {
        text: 'Pickup:',
        margin: [0, 15, 0, 0],
      },
      {
        text: `Shipment should be at warehouse no later than ${shipmentTime || ''
          }`,
        style: 'pickup',
      },
    ],
    border,
  };

  return columnPickup;
};

const getFlightDetail = (quote, isFirstRow, showToLeg = true) => {
  let fleg = null;
  let tleg = null;
  let vialeg = null;
  const {
    selected_flight,
    selected_flight_review,
  } = quote;

  // console.log("selected_flight", selected_flight);
  // console.log("selected_flight_review", selected_flight_review);
  if (selected_flight && selected_flight.fleg) {
    fleg = selected_flight.fleg;
    tleg = selected_flight.tleg;
    vialeg = selected_flight.vialeg;
  } else if (selected_flight_review) {
    fleg = selected_flight_review.fleg;
    tleg = selected_flight_review.tleg;
    vialeg = selected_flight_review.vialeg;
  }

  const flightStack = [];
  flightStack.push({
    text: 'Flight Details',
    style: 'columnTitle',
  });

  let flight = fleg;
  if (!isFirstRow && tleg && tleg.fnumber && showToLeg) {
    flight = tleg;
  }

  const viaList = [];
  if (vialeg && vialeg.tport) {
    if (vialeg.fport === fleg.tport) {
      viaList.push(fleg.tport);
    } else {
      viaList.push(vialeg.tport);
    }

    if (vialeg.tport === tleg.fport) {
      viaList.push(vialeg.tport);
    } else {
      viaList.push(tleg.fport);
    }
  } else if (tleg.tport) {
    viaList.push(tleg.fport);
  }

  const dTime = BookingHelper.getDate(flight.std, 'DD/MM/YYYY HH:mm');
  const aTime = BookingHelper.getDate(flight.sta, 'DD/MM/YYYY HH:mm');
  const duration = flight.duration ? flight.duration : BookingHelper.getDuration(dTime, aTime);

  flightStack.push(
    `${fleg.fport}-${tleg.tport || fleg.tport} (Via ${viaList.join('-')})`
  );
  flightStack.push(`Flight ${flight.fnumber || ''}`);
  flightStack.push(`ETD: ${dTime.format('DD/MM/YY HH:mm')}`);
  flightStack.push(`ETA: ${aTime.format('DD/MM/YY HH:mm')}`);
  flightStack.push(`Duration: ${duration}`);

  const rowFlight = [
    {
      margin: [0, 10, 0, 0],
      image: listIcons['airplan'],
      fit: [80, 35],
      alignment: 'left',
      border,
    },
    {
      stack: flightStack,
      border: [1, 0, 0, 0],
    },
    {
      text: '',
      border,
    },
    isFirstRow ? getPickupInfo(fleg, tleg) : { text: '', border },
  ];

  return rowFlight;
};

const getTruck = (quote, isFirstRow) => {
  let {
    selected_flight_review,
    // selected_flight_review: { fleg, tleg },
    selected_flight: { fleg, tleg, vialeg },
    pickupCity,
    pickupCompanyName,
    pickupComments,
    pickupAddress,
    pickupCountry,
    pickupNameOfContact,
    pickupEmail,
    pickupPhoneNumber,

    pickupPostalCode,
    deliverCity,
    deliverCompanyName,
    deliverComments,
    deliverAddress,
    deliverCountry,
    deliverNameOfContact,
    deliverEmail,
    deliverPhoneNumber,
    deliverPostalCode,
  } = quote;

  if (selected_flight_review) {
    fleg = selected_flight_review.fleg;
    tleg = selected_flight_review.tleg;
    vialeg = selected_flight_review.vialeg;
  }

  const truckStack = [];
  const addressStack = [];
  truckStack.push({
    text: `${isFirstRow ? 'Pickup From' : 'Deliver To'}`,
    style: 'columnTitle',
  });
  addressStack.push({
    text: '',
    margin: [0, 15, 0, 0],
  });
  addressStack.push('Address');

  if (isFirstRow) {
    truckStack.push(`${fleg.fport}-${fleg.tport}`);

    addressStack.push(`${pickupCompanyName || ''}`);
    addressStack.push(`${pickupNameOfContact || ''}`);
    addressStack.push(`${pickupEmail || ''}`);
    addressStack.push(`${pickupPhoneNumber || ''}`);
    addressStack.push(`${pickupAddress || ''}`);

    let pickupAdd = [];
    if (pickupCountry && pickupCountry.trim()) pickupAdd.push(pickupCountry);
    if (pickupCity && pickupCity.trim()) pickupAdd.push(pickupCity);
    if ((pickupCountry && pickupCountry.trim()) || (pickupCity && pickupCity.trim())) {
      addressStack.push(`${pickupAdd.join(', 11111')}`);
    }

    addressStack.push(`${pickupComments || ''}`);
  } else {
    truckStack.push(`${tleg.fport}-${tleg.tport}`);
    const aTime = BookingHelper.getDate(tleg.sta, 'DD/MM/YYYY HH:mm');
    truckStack.push(`ETA: ${aTime.format('DD/MM/YY HH:mm')}`);

    addressStack.push(`${deliverCompanyName || ''}`);
    addressStack.push(`${deliverNameOfContact || ''}`);
    addressStack.push(`${deliverEmail || ''}`);
    addressStack.push(`${deliverPhoneNumber || ''}`);
    addressStack.push(`${deliverAddress || ''}`);

    let deliverAdd = [];
    if (deliverCountry && deliverCountry.trim()) deliverAdd.push(deliverCountry);
    if (deliverCity && deliverCity.trim()) deliverAdd.push(deliverCity);
    if ((deliverCountry && deliverCountry.trim()) || (deliverCity && deliverCity.trim())) {
      addressStack.push(`${deliverAdd.join(',22222 ')}`);
    }
    addressStack.push(`${deliverComments || ''}`);
  }

  const rowTruck = [
    {
      margin: [0, 10, 0, 0],
      image: listIcons['truck'],
      fit: [80, 35],
      alignment: 'left',
      border,
    },
    {
      stack: truckStack,
      border: [1, 0, 0, 0],
    },
    {
      stack: addressStack,
      border,
    },
    isFirstRow ? getPickupInfo(fleg, tleg) : { text: '', border },
  ];

  return rowTruck;
};

const getContent = (quote, price, cur) => {
  const {
    unit_type,
    unit_total,
    unit_length,
    unit_items,
    selected_flight,
    selected_flight_review,
    deliver_from,
    deliver_to,
    deliver_from_airport,
    deliver_to_airport,
  } = quote;

  const rowEmpty = [
    { text: '', border },
    { text: '', border, margin: [10, 5] },
    { text: '', border },
    { text: '', border },
  ];

  let fromAirport = false;
  let toAirport = false;
  if (deliver_from == 'Airport' && deliver_from_airport.flightport == 'Y') {
    fromAirport = true;
  }
  if (deliver_to == 'Airport' && deliver_to_airport.flightport == 'Y') {
    toAirport = true;
  }

  const tranportList = [];
  if (selected_flight_review || selected_flight) {
    if (fromAirport) {
      // First Flight
      tranportList.push(getFlightDetail(quote, true));
      if (!toAirport) {
        // Second Truck
        tranportList.push(rowEmpty);
        tranportList.push(getTruck(quote));
      }
    } else {
      // First Truck
      tranportList.push(getTruck(quote, true));
      if (toAirport) {
        // Second Truck
        tranportList.push(rowEmpty);
        tranportList.push(getFlightDetail(quote, false, false));
      } else {
        // Second Flight
        tranportList.push(rowEmpty);
        tranportList.push(getFlightDetail(quote, false, false));

        // Third Truck
        tranportList.push(rowEmpty);
        tranportList.push(getTruck(quote));
      }
    }
  }

  const content = [
    {
      layout: {
        vLineHeight: () => {
          return 10;
        },
        vLineWidth: () => {
          return 2;
        },
        vLineColor: () => {
          return '#0E2957';
        },
        paddingLeft: () => {
          return 10;
        },
      },
      margin: [0, 20, 0, 0],
      table: {
        widths: ['20%', '20%', '30%', '*'],
        body: tranportList.length > 0 ? tranportList : ['', '', '', ''],
      },
    },
  ];

  const commodityHeader = [
    {
      text: 'Pieces',
      style: 'tbHeader',
    },
    {
      text: 'Length',
      style: 'tbHeader',
    },
    {
      text: 'Width',
      style: 'tbHeader',
    },
    {
      text: 'Height',
      style: 'tbHeader',
    },
    {
      text: 'Volume (CBM)',
      style: 'tbHeader',
    },
  ];

  let tableWidth = ['18%', '18%', '18%', '18%', '*'];
  let isULD = false;
  if (unit_type.value === 'uld') {
    isULD = true;
    commodityHeader.unshift({
      text: 'Uld',
      style: 'tbHeader',
    });
    tableWidth = ['15%', '15%', '15%', '15%', '15%', '*'];
  }

  let isShowEmptyTable = true;
  const tableBody = [];
  const unitValue = unit_length && unit_length.value ? unit_length.value : '';
  if (unit_items && unit_items.length > 0) {
    tableBody.push(commodityHeader);
    unit_items.forEach((item, index) => {
      const {
        item_pieces,
        item_length,
        item_width,
        item_height,
        item_volume,
        item_uld,
      } = item;
      let row = [
        {
          text: `${item_pieces || ''}`,
          style: 'tbContent',
        },
        {
          text: `${item_length || ''} ${unitValue}`,
          style: 'tbContent',
        },
        {
          text: `${item_width || ''} ${unitValue}`,
          style: 'tbContent',
        },
        {
          text: `${item_height || ''} ${unitValue}`,
          style: 'tbContent',
        },
        {
          text: `${BookingHelper.roundOff3Decimal(item_volume) || ''} ${unitValue}3`,
          style: 'tbContent',
        },
      ];

      if (isULD) {
        row.unshift({
          text: `${item_uld || ''} cm`,
          style: 'tbContent',
        });
      }

      tableBody.push(row);
    });
  } else {
    if (isShowEmptyTable) {
      tableBody.push(commodityHeader);
    }
    let emptyBody = ['', '', '', '', ''];
    if (isULD) {
      emptyBody.push('');
    }
    tableBody.push(emptyBody);
  }

  const commodityTable = {
    headerRows: 1,
    heights: 18,
    widths: tableWidth,
    body: tableBody,
  };

  const { tcw, total_pieces, total_volume, total_weight } = unit_total;
  const commodityDetails = {
    margin: [0, 20, 0, 0],
    columns: [
      {
        stack: [
          { text: 'Commodity Details', style: 'categoryTitle' },
          'Consolidation',
        ],
        margin: [12, 0, 0, 0],
        width: '20%',
      },
      {
        margin: [2, 0, 0, 0],
        layout: !isShowEmptyTable ? 'noBorders' : {},
        table: commodityTable,
        width: '*',
      },
      {
        stack: [
          `Total Number of pieces: ${total_pieces || 0}`,
          `Total Volume (CBM): ${total_volume || 0}`,
          `Total Weight: ${total_weight || 0} kg`,
          `Total Chargable Weight: ${tcw || 0} kg`,
        ],
        margin: [15, 0, 0, 0],
        color: '#0E2957',
        fontSize: 10,
        width: '30%',
      },
    ],
  };
  content.push(commodityDetails);

  const {
    shippingCompanyName,
    shippingIATA1,
    shippingIATA2,
    receivingCompanyName,
    receivingIATA1,
    receivingIATA2,
    consignorAddress,
    consignorCity,
    consignorCompanyName,
    consignorCountry,
    consignorPostalCode,
    consigneeAddress,
    consigneeCity,
    consigneeCompanyName,
    consigneeCountry,
    consigneePostalCode,
  } = quote;

  const shippingAgent = [];
  const receivingAgent = [];
  const consignor = [];
  const consignee = [];

  shippingAgent.push({
    text: 'Shipping Agent',
    style: 'columnTitle',
  });

  receivingAgent.push({
    text: 'Receiving Agent',
    style: 'columnTitle',
  });

  consignor.push({
    text: 'Consignor/Shipper Details',
    style: 'columnTitle',
  });

  consignee.push({
    text: 'Consignee/Importer Details',
    style: 'columnTitle',
  });

  shippingAgent.push(shippingCompanyName || '');
  if (shippingIATA1) {
    shippingAgent.push(`IATA CODE: ${shippingIATA1}-${shippingIATA2}`);
  }

  receivingAgent.push(receivingCompanyName || '');
  if (receivingIATA1) {
    receivingAgent.push(`IATA CODE: ${receivingIATA1}-${receivingIATA2}`);
  }


  const cnorAddress = [];
  if (consignorCountry && consignorCountry.trim()) cnorAddress.push(consignorCountry);
  if (consignorCity && consignorCity.trim()) cnorAddress.push(consignorCity);
  if (consignorCompanyName && consignorCompanyName.trim()) consignor.push(consignorCompanyName || '');
  if (cnorAddress) {
    consignor.push(`${cnorAddress.join(', ')}`);
  }

  if (consignorAddress && consignorAddress.trim())
    consignor.push(`Address: ${consignorAddress || ''}`);
  if (consignorPostalCode && consignorPostalCode.trim())
    consignor.push(`Post Code: ${consignorPostalCode || ''}`);

  const cneeAddress = [];
  if (consigneeCountry && consigneeCountry.trim()) cneeAddress.push(consigneeCountry);
  if (consigneeCity && consigneeCity.trim()) cneeAddress.push(consigneeCity);
  if (consigneeCompanyName && consigneeCompanyName.trim()) consignee.push(consigneeCompanyName || '');
  if (cneeAddress) {
    consignee.push(`${cneeAddress.join(', ')}`);
  }
  if (consigneeAddress && consigneeAddress.trim())
    consignee.push(`Address: ${consigneeAddress || ''}`);
  if (consigneePostalCode && consigneePostalCode.trim())
    consignee.push(`Post Code: ${consigneePostalCode || ''}`);

  const participantTable = {
    margin: [0, 30, 0, 0],
    fillColor: '#E6E6E6',
    columns: [
      {
        layout: 'noBorders',
        padding: [20, 20],
        table: {
          widths: ['25%', '35%', '*'],
          body: [
            [
              '',
              {
                margin: [0, 15, 0, 0],
                stack: shippingAgent,
              },
              {
                margin: [0, 15, 0, 0],
                stack: receivingAgent,
              },
            ],
            [
              {
                margin: [0, 5, 0, 0],
                text: 'Participants',
                style: 'categoryTitle',
                alignment: 'center',
              },
              {
                margin: [0, 10, 0, 15],
                stack: consignor,
              },
              {
                margin: [0, 10, 0, 15],
                stack: consignee,
              },
            ],
          ],
        },
        columnGap: 20,
      },
    ],
  };
  content.push(participantTable);

  if (price !== '') {
    const priceTable = {
      margin: [0, 30, 30, 0],
      fillColor: '#03295a',
      columns: [
        {
          layout: 'noBorders',
          padding: [20, 20],
          table: {
            widths: ['50%', '55%'],
            body: [
              [
                {
                  margin: [5, 5, 5, 5],
                  text: 'TOTAL',
                  style: 'priceTitle',
                  alignment: 'left',
                },
                {
                  margin: [5, 5, 5, 5],
                  text: price + ' ' + cur,
                  style: 'priceTitle',
                  alignment: 'right',
                }
              ],
            ],
          },
          columnGap: 20,
        },
      ],
    };
    content.push(priceTable);
  }
  return content;
};

const exportBookingPDF = (quote, fileNameExport = 'cal-quote-', titlePDF = 'Your Quote', price = '', cur = '') => {
  const { CProfNum } = quote;
  const docDefinition = {
    header: getHeader(titlePDF),
    content: getContent(quote, price, cur),
    pageSize: 'A4',
    pageOrientation: 'portrait',
    defaultStyle: {
      font: 'Exo2',
      color: '#666666',
      fontSize: 10,
    },
    styles: {
      header: {
        color: '#525252',
        fontSize: 20,
        alignment: 'center',
      },
      smallTitle: {
        fontSize: 12,
        color: '#525252',
      },
      columnTitle: {
        fontSize: 13,
        color: '#333333',
      },
      categoryTitle: {
        fontSize: 14,
        color: '#666666',
      },
      priceTitle: {
        fontSize: 14,
        color: '#ffffff',
      },
      pickup: {
        bold: true,
        color: '#0E2957',
      },
      tbHeader: {
        color: '#333',
        fillColor: '#ccc',
        alignment: 'center',
        margin: [0, 2, 0, 0],
      },
      tbContent: {
        fillColor: '#F2F2F2',
        alignment: 'center',
        margin: [0, 2, 0, 0],
      },
    },
    pageMargins: [20, 70, 20, 20],
  };

  const fileName = `${fileNameExport}${CProfNum || moment().utc().format('YYYYMMDDHHmmss')}.pdf`;
  pdfMake.createPdf(docDefinition).download(fileName);
  // pdfMake.createPdf(docDefinition).print();
};

export { exportBookingPDF };
